export default __webpack_public_path__ + "static/media/or-9.403ea1e6.jpg";